export default "__VITE_ASSET__SFkrBxDQ__"